module.exports = __webpack_public_path__ + "static/img/zybj.8ff81c46.png";